import { useLocalSearchParams, type UnknownOutputParams } from 'expo-router'

import { PublicationScreen } from '@/src/features/publication/ui/screens/PublicationScreen'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

export type TPublicationPageSearchParams = {
  section?: 'comments'
  publicationTrackingSource?: PUBLICATION_TRACKING_SOURCE
  source: TRACKING_SOURCE
}

const PublicationRouterPage = () => {
  const searchParams = useLocalSearchParams<{ id: string } & TPublicationPageSearchParams & UnknownOutputParams>()
  const {
    id: stringId,
    section,
    publicationTrackingSource = PUBLICATION_TRACKING_SOURCE.PUBLICATION_PAGE,
    source = TRACKING_SOURCE.UNDEFINED,
  } = searchParams

  const id = stringId && parseInt(stringId, 10)

  if (!id) return null

  return (
    <PublicationScreen
      id={id}
      section={section}
      source={source}
      publicationTrackingSource={publicationTrackingSource}
      searchParams={searchParams}
    />
  )
}

export default PublicationRouterPage
